/**
 * Mocking client-server processing
 */
import { host } from '../config'
import Vue from '../lib/Vue'
const http = Vue.prototype.$http

export default {
  getProducts (forCustomer, cb) {
    http.get(host + `/api/product/list${ forCustomer ? '?forCustomer='+forCustomer :''}`, {credentials: 'include'}).then((res)=>{
                    cb(res.data);
        });
  },

  buyProducts (forCustomer, order, cb, errorCb) {
    http.post(host + `/api/order${ forCustomer ? '?forCustomer='+forCustomer :''}`, {
           ...order
        }).then((response) => {
                    cb(response.data);
                  });
  },

  getAddresses (forCustomer, cb) {
    http.get(host + `/api/address/list${ forCustomer ? '?forCustomer='+forCustomer :''}`).then((response) => {
                    cb(response.data.data);
                  });
  },

  updateAddresses (address) {
    let token = localStorage.getItem('roupooToken');

    http.patch(host + `/admin/api/v1/address/${address.id}.json`,{data:address}).then((response) => {
                  });
  },

  newAddress (forCustomer, {tel, name, street}, cb, errorCb) {
    http.post(host + `/api/address${ forCustomer ? '?forCustomer='+forCustomer :''}`,{tel, name, street})
    .then((response) => {
                    cb(response.data.data);
                  })
  },


  editAddress (forCustomer, {tel, name, street, _id}, cb, errorCb) {
    http.put(host + '/api/address/' + _id + (forCustomer ? '?forCustomer='+forCustomer :''),{tel, name, street, _id})
    .then((response) => {
                    cb(response.data.data);
    })
  },

  getOrders(cb) {
    http.get(host + `/api/order/list`).then((response) => {
                cb(response.data.data);
   });
  },
}



// WEBPACK FOOTER //
// ./src/api/shop.js